import DropCard from "Components/DropCard/DropCard";
import { ChevronDown } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getStageDetails,
  getStages,
} from "../../Redux/ChallengeOverview/ChallengeOverviewAction";
import { useAuth } from "@clerk/clerk-react";

function StageChange({ variant }) {
  const { challengeStageInfo, challengeCurrency, stages } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );
  const [stage, setStage] = useState("-");
  const [stagesData, setStagesData] = useState([]);

  const params = useParams();
  const { id } = params;

  const dispatch = useDispatch();
  const { getToken } = useAuth();

  useEffect(() => {
    if (id) {
      dispatch(getStages(getToken, id));
    }
  }, [id]);

  useEffect(() => {
    if (id && challengeStageInfo?.challengeId != id)
      dispatch(getStageDetails(getToken, id));
  }, [id]);

  useEffect(() => {
    if (Object.keys(challengeStageInfo)?.length > 0) {
      if (challengeStageInfo?.Challenge?.isFree) {
        if (stages?.stages?.length > 0) {
          const st = stages?.stages?.map((item) => ({
            label: `Stage ${item?.sequence}`,
            value: item?.id,
          }));

          if (st?.length != stages?.nbStages) {
            //add stages to the array as many as the nbStages
            let diff = parseInt(stages?.nbStages) - parseInt(st?.length);
            let i = 0;
            while (i < diff) {
              st.push({
                label: `Stage ${st?.length + 1}`,
                value: "disabled",
              });
              i++;
            }
          }
          setStagesData(st);
        }
      } else {
        if (stages?.stages?.length > 0) {
          let liveFound = false;
          const st = stages?.stages?.map((item) => {
            if (item?.isLive) {
              liveFound = true;
              return {
                label: `Live Stage`,
                value: item?.id,
              };
            } else {
              liveFound = false;
              return {
                label: `Stage  ${item?.sequence}`,
                value: item?.id,
              };
            }
          });

          if (st?.length != stages?.nbStages) {
            //add stages to the array as many as the nbStages
            let diff = parseInt(stages?.nbStages) - parseInt(st?.length);
            let i = 0;
            while (i < diff) {
              st.push({
                label: `Stage ${st?.length + 1}`,
                value: "disabled",
              });
              i++;
            }
          }
          if (!liveFound) {
            st.push({
              label: `Live Stage`,
              value: "disabled",
            });
          }
          setStagesData(st);
        }
      }
    }
  }, [stages, challengeStageInfo]);

  useEffect(() => {
    if (
      challengeStageInfo?.sequence != stage?.value &&
      !challengeStageInfo?.isLive
    ) {
      setStage({
        label: `${
          challengeStageInfo?.sequence
            ? "Stage " + challengeStageInfo?.sequence
            : "Stage"
        }`,
        value: challengeStageInfo?.id,
        challengeId: challengeStageInfo?.challengeId,
      });
    } else if (
      challengeStageInfo?.sequence != stage?.value &&
      challengeStageInfo?.isLive
    ) {
      setStage({
        label: `Live Stage`,
        value: challengeStageInfo?.id,
        challengeId: challengeStageInfo?.challengeId,
      });
    }
  }, [challengeStageInfo]);

  useEffect(() => {
    if (
      stage?.value != challengeStageInfo?.id &&
      id &&
      challengeStageInfo?.id &&
      stage?.value
    ) {
      dispatch(getStageDetails(getToken, id, stage));
    }
  }, [stage, id]);

  return (
    <>
      {variant == "secondary" ? (
        <DropCard
          onlyOne={true}
          title={
            <div className="text-lg font-N_Bold flex items-center gap-2 text-nowrap ">
              {stage?.label}
              <ChevronDown color="var(--white-opacity)" size={"1rem"} />{" "}
            </div>
          }
          data={stagesData}
          selected={stage}
          setSelected={(data) => setStage(data)}
        />
      ) : (
        <div className="bg-border-darkNew  flex items-center text-primary text-base py-2 px-4 rounded-lg cursor-pointer gap-4 sm:justify-start justify-between">
          {" "}
          <DropCard
            data={stagesData}
            title={
              <div className="flex flex-row gap-2 items-center text-base font-N_Roman text-white">
                {stage?.label || "Select Stage"} <ChevronDown size={"1rem"} />
              </div>
            }
            selected={stage}
            setSelected={(data) => setStage(data)}
          />
          {challengeStageInfo?.status && (
            <div
              className="text-xs font-G_Bold flex items-center  gap-2 text-primary py-[0.15rem] xl:px-6 px-4 rounded-full"
              style={{
                color:
                  challengeStageInfo?.status == "ACTIVE"
                    ? "var(--green)"
                    : challengeStageInfo?.status == "PASSED"
                    ? "var(--blue)"
                    : challengeStageInfo?.status == "BREACHED"
                    ? "var(--red)"
                    : challengeStageInfo?.status == "PENDING"
                    ? "var(--yellow)"
                    : "var(--white)",
                backgroundColor:
                  challengeStageInfo?.status == "ACTIVE"
                    ? "var(--green-opacity)"
                    : challengeStageInfo?.status == "PASSED"
                    ? "var(--blue-opacity)"
                    : challengeStageInfo?.status == "BREACHED"
                    ? "var(--red-opacity)"
                    : challengeStageInfo?.status == "PENDING"
                    ? "var(--yellow-opacity)"
                    : "var(--white)",
              }}
            >
              {" "}
              {challengeStageInfo?.status || "-"}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default StageChange;
